<div class="content">
  <div class="form-cont">
    <div class="row">
      <div class="col-xl-3 col-lg-4 col-md-5">
        <app-stickybar></app-stickybar>
      </div>

      <div class="col-xl-9 col-lg-8 col-md-7">
        <div class="subscription-container">
          <div class="subscription-details">
            <div class="tabs-container" style="padding: 0 0 40px 0 !important">
              <h1 style="margin-top: -20px; margin-bottom: -20px">
                Subscription Details
              </h1>
            </div>
            <div class="unique-pricing-container">
              <ng-container *ngIf="getUniquePlans().length > 0; else noPlans">
                <ng-container *ngFor="let plan of getUniquePlans()">
                  <div class="unique-card">
                    <div class="unique-card-header">
                      <img
                        class="unique-card-img"
                        src="../../../../../assets/icons/theme_icons/medal (2).png"
                        alt="Plan Icon"
                      />
                      <div class="unique-card-body">
                        <p class="unique-card-tagline">
                          For Essential Wellness
                        </p>
                        <h3 class="unique-card-title">
                          {{ plan.subBundle.bundle_name }}
                        </h3>
                      </div>
                    </div>
                    <p class="unique-card-description">
                      {{ plan.description }}
                    </p>
                    <h4 class="unique-card-included-title">What's included</h4>
                    <ul class="unique-card-features">
                      <li
                        *ngFor="let item of plan.features"
                        class="unique-card-feature-item"
                      >
                        <img
                          src="assets/icons/theme_icons/check-box.png"
                          class="unique-card-feature-icon"
                        />
                        <span>{{ item.feature_name }}</span>
                      </li>
                    </ul>
                    <div style="flex-grow: 1"></div>
                    <button class="unique-card-button button_class">
                      Subscribed
                    </button>
                  </div>
                </ng-container>
              </ng-container>

              <ng-template #noPlans>
                <div class="Nosubscription">
                  <div style="margin-bottom: 10px">
                    You currently don’t have any active subscription.
                  </div>
                  <div style="margin-bottom: 10px">
                    Choose a plan to access more features and benefits.
                  </div>
                </div>
              </ng-template>
            </div>
            <div class="upgrade-section">
              <button
                class="btn choose-plan-btn button_class"
                (click)="moveToSelectCards(getUniquePlans().length)"
              >
                {{
                  getUniquePlans().length > 0
                    ? "Explore More Plans"
                    : "Choose Plan Now"
                }}
              </button>
              <!-- <button
                class="btn choose-plan-btn button_class"
                (click)="manageEcocash()"
              >
                Manage Ecocash
              </button> -->
            </div>
            <div
              class="manage-plan"
              style="background-color: #edf5fb !important"
            >
              <div style="display: flex; justify-content: space-between">
                <span style="display: flex">
                  <h3
                    class="plan-m"
                    [class.active-tab]="isActiveTab('manage')"
                    (click)="setActiveTab('manage')"
                  >
                    Manage Plan
                  </h3>
                  <h3
                    class="plan-m"
                    style="margin-left: 30px"
                    [class.active-tab]="isActiveTab('billing')"
                    (click)="setActiveTab('billing')"
                  >
                    Billing History
                  </h3>
                </span>
              </div>
              <div class="card-body" *ngIf="activeTab === 'manage'">
                <app-ag-grid-table
                  #agGridRef
                  [rowData]="rowData"
                  [columnDefs]="colDefs"
                  [currentRowSelectedIndex]="currentRowSelectedIndex"
                  [parentContext]="this"
                  [paginationPageSize]="paginationPageSize"
                  (gridReady)="onGridReady($event)"
                  (reloadTable)="reload($event)"
                ></app-ag-grid-table>
              </div>
              <app-billing
                *ngIf="activeTab === 'billing'"
                [billingId]="12"
              ></app-billing>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-modal-overlay" *ngIf="showPopup">
      <div class="custom-modal">
        <h2>Add Category</h2>
        <div class="button-group">
          <span style="display: ruby">
            <span class="toggle-btn" (click)="toggleAdditional()">
              <i [ngClass]="showAdditional ? 'fa fa-minus' : 'fa fa-plus'"></i>
            </span>
            <span style="color: black; margin-left: 5px; font-size: 17px"
              >Add Additional Categories</span
            >
          </span>
        </div>

        <div
          *ngIf="showAdditional"
          class="additional-section"
          [ngStyle]="healthTips.length ? { 'overflow-y': 'scroll' } : {}"
        >
          <ng-container *ngIf="healthTips.length">
            <span style="display: flex; justify-content: space-between">
              <span style="display: ruby">
                <input
                  class="custom-checkbox"
                  type="checkbox"
                  [checked]="isAllSelected()"
                  (change)="toggleSelectAll($event)"
                />
                <span style="color: black; font-size: 14px; font-weight: 500"
                  >Select All</span
                >
              </span>
              <span class="prefer">Select Prefer Language</span>
            </span>

            <label
              *ngFor="let cat of healthTips"
              class="additional-option newopt"
            >
              <span style="display: ruby">
                <input
                  class="custom-checkbox"
                  type="checkbox"
                  [checked]="isCategorySelected(cat.category_id)"
                  (change)="toggleCategory(cat.category_id, $event)"
                />
                <span style="color: black; font-size: 14px; font-weight: 400">{{
                  cat.category_name
                }}</span>
              </span>

              <select
                [ngModel]="getCategoryLanguage(cat.category_id)"
                (ngModelChange)="updateLanguage(cat.category_id, $event)"
                [disabled]="!isCategorySelected(cat.category_id)"
                [ngStyle]="{
                  cursor: isCategorySelected(cat.category_id)
                    ? 'pointer'
                    : 'not-allowed',
                }"
              >
                <option value="" disabled selected>Select Language</option>
                <option *ngFor="let lang of languages" [value]="lang">
                  {{ lang }}
                </option>
              </select>
            </label>
          </ng-container>

          <ng-container *ngIf="healthTips.length <= 0">
            <p
              style="
                text-align: center;
                padding: 10px;
                font-size: 17px;
                color: black;
              "
            >
              You’ve already picked all available categories. Hang tight — new
              ones will be added soon.
            </p>
          </ng-container>
        </div>
        <div
          class="button-group"
          style="
            display: flex;
            justify-content: space-between;
            padding-top: 50px;
          "
        >
          <button
            style="
              background: white;
              color: black;
              font-weight: 400;
              border: 1px solid gray;
            "
            (click)="closePopup()"
            class="save-btn"
          >
            Back
          </button>
          <button (click)="saveChanges()" class="save-btn">Subscribe</button>
        </div>
      </div>
    </div>
    <div
      class="custom-modal-overlay"
      *ngIf="showUnsubCat"
      style="z-index: 9999"
    >
      <div class="custom-modal">
        <div class="button-group">
          <span style="display: ruby">
            <span class="toggle-btn" (click)="toggleRemoval()">
              <i [ngClass]="showRemoval ? 'fa fa-minus' : 'fa fa-plus'"></i>
            </span>
            <span style="color: black; margin-left: 5px; font-size: 17px"
              >Remove Additional Categories</span
            >
          </span>
        </div>

        <div
          *ngIf="showRemoval"
          class="additional-section"
          [ngStyle]="healthTips.length ? { 'overflow-y': 'scroll' } : {}"
        >
          <ng-container *ngIf="healthTips.length">
            <span style="display: flex; justify-content: space-between">
              <span style="display: ruby">
                <input
                  class="custom-checkbox"
                  type="checkbox"
                  [checked]="selectAllRemoval"
                  (change)="toggleRemovalSelectAll($event)"
                />
                <span style="color: black; font-size: 14px; font-weight: 500">
                  {{ selectAllRemoval ? "Deselect All" : "Select All" }}
                </span>
              </span>
            </span>
            <label
              *ngFor="let cat of healthTips"
              class="additional-option newopt"
            >
              <span style="display: ruby">
                <input
                  class="custom-checkbox"
                  type="checkbox"
                  [checked]="isCategoryRemovalSelected(cat.category_id)"
                  (change)="toggleSingleCheckbox(cat.category_id, $event)"
                />
                <span style="color: black; font-size: 14px; font-weight: 400">{{
                  cat.category_name
                }}</span>
              </span>
            </label>
          </ng-container>

          <ng-container *ngIf="healthTips.length <= 0">
            <p
              style="
                text-align: center;
                padding: 10px;
                font-size: 17px;
                color: black;
              "
            >
              No categories left to remove. Check back later for updates.
            </p>
          </ng-container>
        </div>

        <div
          class="button-group"
          style="
            display: flex;
            justify-content: space-between;
            padding-top: 50px;
          "
        >
          <button
            style="
              background: white;
              color: black;
              font-weight: 400;
              border: 1px solid gray;
            "
            (click)="this.showUnsubCat = !this.showUnsubCat"
            class="save-btn"
          >
            Back
          </button>
          <button (click)="openConfirm()" class="save-btn">Unsubscribe</button>
        </div>
      </div>
    </div>

    <div *ngIf="usubscribeUser" class="unsub-overlay">
      <div class="unsub-blur"></div>
      <div class="unsub-content">
        <h3 class="unsub-title">Are you sure you want to cancel your plan?</h3>
        <div class="unsub-actions">
          <button
            (click)="confirmCancel()"
            class="unsub-confirm-btn button_class"
          >
            Yes, Cancel
          </button>
          <button (click)="unsubscribeCurrentUser()" class="unsub-cancel-btn">
            No, Go Back
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="usubscribeCate" class="unsub-overlay">
      <div class="unsub-blur"></div>
      <div class="unsub-content">
        <h3 class="unsub-title">
          {{
            "Are you sure you want to unsubscribe? By doing so, you may lose access to premium services such as doctor consultations and ambulance bookings."
          }}
        </h3>
        <div class="unsub-actions">
          <button
            (click)="this.usubscribeCate = false"
            class="unsub-cancel-btn"
          >
            No, Go Back
          </button>

          <button
            (click)="UnSubCategory()"
            class="unsub-confirm-btn button_class"
          >
            Yes, Unsubscribe
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="popupVisible" class="popup-backdrop">
      <div class="popup-content">
        <h2 class="popup-heading">Plan Details</h2>

        <div class="popup-row">
          <span class="popup-label">Plan Name -</span>
          <span class="popup-value">
            {{ popupData?.subBundle?.bundle_name || "N/A" }}
            {{ popupData?.subPack?.pack_name || "" }}
          </span>
        </div>

        <div class="popup-row">
          <span class="popup-label">Billing Type -</span>
          <span class="popup-value">
            {{
              popupData?.is_addon == 1
                ? "Additional Category"
                : popupData?.is_addon == 0
                  ? "Main Plan"
                  : "N/A"
            }}
          </span>
        </div>

        <div class="popup-row">
          <span class="popup-label">Subscription Number -</span>
          <span class="popup-value">
            {{ userSubscription.userData.phone || "N/A" }}
          </span>
        </div>

        <div class="popup-row">
          <span class="popup-label">Transaction Number -</span>
          <span class="popup-value">
            {{ popupData?.sub_phone_number || "N/A" }}
          </span>
        </div>

        <!-- <div class="popup-row">
          <span class="popup-label">Category -</span>
          <span class="popup-value">{{
            popupData?.category?.category_name || "N/A"
          }}</span>
        </div> -->

        <div class="popup-row">
          <span class="popup-label">Start Date -</span>
          <span class="popup-value">{{
            popupData?.start_date
              ? (popupData?.first_billing_date | date: "MMM d, y")
              : "N/A"
          }}</span>
        </div>

        <div class="popup-row">
          <span class="popup-label">Renewal Date -</span>
          <span class="popup-value">{{
            popupData?.renewal_date
              ? (popupData?.renewal_date | date: "MMM d, y")
              : "N/A"
          }}</span>
        </div>

        <div class="popup-row">
          <span class="popup-label">Status -</span>
          <span
            [ngSwitch]="popupData?.subStatus?.sub_status_id"
            [style.color]="
              [1, 15].includes(popupData?.subStatus?.sub_status_id)
                ? 'green'
                : [9, 4].includes(popupData?.subStatus?.sub_status_id)
                  ? 'red'
                  : 'black'
            "
          >
            <ng-container *ngSwitchCase="1">✅ Active</ng-container>
            <ng-container *ngSwitchCase="15">✅ Active</ng-container>

            <ng-container *ngSwitchCase="9">❌ Failed</ng-container>
            <ng-container *ngSwitchCase="4">❌ Failed</ng-container>

            <ng-container *ngFor="let id of [0, 2, 14, 8, 19]">
              <ng-container *ngSwitchCase="id">In Progress</ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="20">Deactivated</ng-container>
            <ng-container *ngSwitchDefault>Unknown</ng-container>
          </span>
        </div>

        <button
          class="popup-bottom-close button_class"
          (click)="closeVisualPopup()"
        >
          Okay
        </button>
      </div>
    </div>

    <div *ngIf="managePopup && !isEditMode" class="manage-ecocash">
      <div class="manage-ecocash-content">
        <div>
          <h2>Manage Ecocash Number</h2>

          <p class="current-number">
            Current Ecocash Number: <b>{{ currentEcoCashNumber }}</b>
          </p>
        </div>
        <div class="btn-box">
          <button (click)="enableEdit()" class="change-btn">Change</button>

          <button (click)="closeManagePopup()" class="ok-btn">Ok</button>
        </div>
      </div>
    </div>

    <div *ngIf="isEditMode" class="manage-ecocash">
      <div class="manage-ecocash-content">
        <div>
          <h2>Manage Ecocash Number</h2>

          <label>Enter New Ecocash Number</label>
          <input
            type="text"
            class="input-box"
            (input)="validateLoginNumber($event)"
            (keydown)="blockNonNumeric($event)"
            [(ngModel)]="editedEcoCashNumber"
            [attr.maxlength]="maxLength"
            [ngClass]="{
              'error-border': contactNumberError && editedEcoCashNumber,
            }"
          />
          <span *ngIf="contactNumberError" class="error-text">
            Enter a valid mobile number!
          </span>
        </div>

        <div class="btn-box">
          <button class="cancel-btn" (click)="cancelEdit()">Cancel</button>
          <button
            class="save-btn"
            [disabled]="isSaveDisabled"
            [ngClass]="{ 'disabled-btn': isSaveDisabled }"
            (click)="saveNumber()"
          >
            Save
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="showOtp">
      <app-add-alternate-number
        [handleDirectShowOtp]="showOtp"
        [phoneNumber]="editedEcoCashNumber"
        (triggerOtpSuccess)="reload($event)"
      ></app-add-alternate-number>
    </div>

    <ngx-spinner
      bdColor="rgba(51, 51, 51, 0.8)"
      size="medium"
      color="skyblue"
      type="ball-clip-rotate"
      [fullScreen]="true"
    >
      <p class="spinner-text">Please wait...</p>
    </ngx-spinner>
  </div>
</div>
